import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Input, Skeleton } from "antd";

import EntityCard from "../../../shared/EntityCard";
import { ReactComponent as SearchIcon } from "../../../../assets/images/search.svg";
import EmptyState from "../../../shared/EmptyState";
import FilterButtons from "../../../shared/FilterButtons";

const { Text } = Typography;

const UserOnboardingScreen = (props: any) => {
  const {
    onboardings,
    loading,
    loaded,
    actions: { getOnboarding },
  } = props;

  const [filteredOnboardings, setFilteredOnboardings] = useState(onboardings);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("ALL");
  const filterProps = [
    { key: "ALL", value: "ALL" },
    { key: "FINISHED", value: "FINISHED" },
    { key: "UNFINISHED", value: "UNFINISHED" },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    if (loaded) return;
    getOnboarding();
  }, []);

  useEffect(() => {
    let filtered = onboardings;

    if (filter === "FINISHED") {
      filtered = filtered.filter((onboarding: any) => onboarding.isFinished);
    } else if (filter === "UNFINISHED") {
      filtered = filtered.filter((onboarding: any) => !onboarding.isFinished);
    }

    if (searchTerm) {
      filtered = filtered.filter((onboarding: any) =>
        onboarding.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredOnboardings(filtered);
  }, [searchTerm, filter, onboardings]);

  const handleFilterChange = (newFilter: string) => {
    setFilter(newFilter);
  };

  if (loading) return <Skeleton active />;

  return (
    <>
      {onboardings && onboardings.length > 0 ? (
        <div>
          <div className="flex flex-row gap-[18px]">
            <Input
              placeholder="Search"
              className="w-1/2"
              prefix={<SearchIcon className="mx-3" />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <FilterButtons
            selectedFilter={filter}
            handleFilterChange={handleFilterChange}
            filterOptions={filterProps}
          />
          <div className="flex flex-wrap gap-4 mt-4  overflow-y-scroll max-h-[calc(100vh-290px)]">
            {filteredOnboardings?.length > 0 ? (
              filteredOnboardings.map((content: any, index: number) => (
                <EntityCard
                  key={content.id}
                  title={content.title}
                  coverImageKey={content.coverImageKey || ""}
                  numberOfEntities={content.steps?.length}
                  entities={"Steps"}
                  footer={
                    <div className="flex flex-row justify-between items-center gap-4">
                      {!content.isFinished ? (
                        <>
                          <Button
                            className="bg-primary-600 text-white border-none text-sm leading-4 font-semibold"
                            onClick={() =>
                              navigate("/user/onboarding/" + content.id)
                            }
                          >
                            View Onboarding
                          </Button>
                        </>
                      ) : (
                        <div className="w-full bg-primary-600 border-none text-white py-[7px] rounded-lg h-8 flex justify-center items-center">
                          <Text className="text-white text-sm font-semibold">
                            Finished
                          </Text>
                        </div>
                      )}
                    </div>
                  }
                />
              ))
            ) : (
              <div className="flex items-center w-full justify-center h-full py-[60px]">
                <EmptyState />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full pb-[60px]">
          <EmptyState />
        </div>
      )}
    </>
  );
};

export default UserOnboardingScreen;
